import React from 'react';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

/* eslint-disable react/prop-types */
const AccountsActions = ({ permissions, settings, openAccountWithholdingModal, openAccountImyFormsModal }) => ({
  id: 'action-column',
  Header: 'View',
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit, ActivityPerms.accountPageView]) && <Link to={ `/account/${ row.original.itemId }` }>
        <button
          type="button"
          className="btn btn-sm btn-sm"
          title="Account Details"
        >
          <span className="icon icon-apps" />
        </button>
      </Link>}
      { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
        && row.original.accountNumber && row.original.accountNumber !== 'N/A'
        && ((row.original.isDirect === 'Yes' && !row.original.hasImyStructure) || !row.original.formExpectsWhs)
        && <button
          className="btn btn-sm "
          type="button"
          onClick={ () => openAccountWithholdingModal(row.original, 'accounts') }
          title="Show Withholding Rates"
        >
          <span className="icon icon-calculator" />
        </button> }
      { AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])
        && ((row.original.isDirect === 'No' && row.original.whsWithinEffectiveRange === true)
            || row.original.hasPublishedWhs || (row.original.hasImyStructure && row.original.formExpectsWhs))
        && <button
          className="btn btn-sm "
          type="button"
          onClick={ () => openAccountImyFormsModal(row.original) }
          title="Show IMY linked forms"
        >
          <span className="icon icon-treeview" />
        </button> }
    </div>
  )
});
/* eslint-enable react/prop-types */

export default AccountsActions;
